import {
  JsonValue,
  ScriptCreateBody,
  ScriptListResult,
  ScriptRunAdHocBody,
  ScriptRunByIdBody,
  ScriptRunOutcome,
  ScriptSafe,
  ScriptUpdateBody,
  ScriptWriteResult,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listWork4MeScripts(): Promise<ScriptListResult> {
  return httpClient.get<ScriptListResult>('/protected/scripts');
}

export async function getWork4MeScript(id: number): Promise<ScriptSafe> {
  return httpClient.get<ScriptSafe>(`/protected/scripts/${id}`);
}

export async function createWork4MeScript(input: ScriptCreateBody): Promise<ScriptWriteResult> {
  return httpClient.post<ScriptWriteResult, ScriptCreateBody>('/protected/scripts', input);
}

export async function updateWork4MeScript(id: number, input: ScriptUpdateBody): Promise<ScriptWriteResult> {
  return httpClient.patch<ScriptWriteResult, ScriptUpdateBody>(`/protected/scripts/${id}`, input);
}

export async function deleteWork4MeScript(id: number): Promise<void> {
  return httpClient.delete<void>(`/protected/scripts/${id}`);
}

export async function runWork4MeScript(id: number, input: JsonValue): Promise<ScriptRunOutcome> {
  return httpClient.post<ScriptRunOutcome, ScriptRunByIdBody>(`/protected/scripts/${id}/run`, { input });
}

export async function runWork4MeScriptBody(body: string, input: JsonValue): Promise<ScriptRunOutcome> {
  return httpClient.post<ScriptRunOutcome, ScriptRunAdHocBody>('/protected/scripts/run', { body, input });
}
